import React from "react";

function About() {
   console.log("Home loaded");
   return (
      <div>
         <h1>About Us</h1>
         <p>hello</p>
      </div>
   );
}

export default About;
